<template lang="pug">
div.pt-2
  smart-table(
    :headers='headers'
    :adapter="adapter"
  )
    template(#header)
      v-btn.mr-2(@click="dialog = true" color="success")
        v-icon(left) mdi-plus
        | Добавить
    template(#value--projects='{ item }')
      add-project-chips(
        :projects="item.projects || []"
        @delete="deleteProjectFromCategory({project_id: $event, category_id: item.id })"
        @open="openAddProject(item)"
      )
    template(#value--action='{ item }')
      .d-flex
        v-btn.rounded.mr-1(color="primary" @click='editItem(item)' fab tile x-small)
          v-icon
            | mdi-pencil
        v-btn.rounded(color="error" @click='deleteCategory(item.id)' fab tile x-small)
          v-icon
            | mdi-trash-can

  v-dialog(v-model='dialog' dark max-width='500px')
    v-card.pa-5
      p.text-h5 {{ formTitle }}
      v-text-field(
        v-model="form.name"
        filled
        label='Название категории'
      )
      p.mb-1.caption.text--darken-1 Если оставить пустым, категория не будет привязана к проекту
      select-project(
        v-model="form.project_id"
        filled
        clearable
      )
      v-btn.mr-4(
        :disabled="!form.name"
        color="success"
        @click="saveCategory"
      ) Сохранить
      v-btn(text @click='dialog = false') Отменить

  v-dialog(v-model='dialogAddProject' dark max-width='500px')
    v-card.pa-5
      p.text-h5 Добавление проекта
      select-project(
        v-model="form.project_id"
        filled
        clearable
      )
      v-btn.mr-4(
        :disabled="!form.project_id"
        color="success"
        @click="addProject"
      ) Сохранить
      v-btn(text @click='dialogAddProject = false') Отменить

  confirm-form-dialog(
    v-model="dialogDelete"
    @accept="acceptDeleteCategory"
    message="Действительно удалить категорию шаблонов?"
  )

</template>
<script>
import AppEditor from '@/components/AppEditor.vue';
import { CRUDQuestionCategory } from '@/services/API/_crud';
import projectService from '@/services/API/project';
import SmartTable from '@/components/SmartTable/index.vue';
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import SelectProject from '@/components/inputs/SelectProject.vue';
import AddProjectChips from '@/components/AddProject/AddProjectChips.vue';

const DEFAULT_FORM = {
  project_id: null,
  name: '',
};

export default {
  components: {
    AppEditor,
    SmartTable,
    ConfirmFormDialog,
    SelectProject,
    AddProjectChips,
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      deleteCategoryId: null,

      dialogAddProject: false,
      addProjectCategory: null,

      headers: [
        { text: 'Название категории', value: 'name', searchable: true },
        { text: 'Проекты', value: 'projects', sortable:false },
        { text: 'Действия', value: 'action', sortable: false },
      ],

      form: { ...DEFAULT_FORM },

    };
  },

  computed: {
    formTitle() {
      return this.form.id ? 'Изменение категории' : 'Новая категория';
    },
    isValidForm() {
      return Object.keys(this.form).every((v) => this.form[v]);
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },

  },

  created() {},

  methods: {
    adapter(options) {
      return CRUDQuestionCategory.getAll({ ...options, 'expand':'projects' });
    },

    editItem(item) {
      this.form = { ...item };
      this.dialog = true;
    },

    deleteCategory(id) {
      this.deleteCategoryId = id;
      this.dialogDelete = true;
    },

    async acceptDeleteCategory() {
      await CRUDQuestionCategory.delete(this.deleteCategoryId);
    },

    openAddProject(category) {
      this.dialogAddProject = true;
      this.addProjectCategory = category;
    },

    async addProject() {
      const { id } = this.addProjectCategory;

      const params = {
        category_ids: [{ category_id:id }],
      };

      try {
        await projectService.attachCategory(this.form.project_id, params);
      } finally {
        this.dialogAddProject = false;
        this.form = { ...DEFAULT_FORM };
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = { ...DEFAULT_FORM };
      });
    },

    async deleteProjectFromCategory({ category_id, project_id }) {
      const params = {
        'category_ids': [category_id],
      };
      await projectService.detachCategory(project_id, params);
    },

    async saveCategory() {
      const response = await CRUDQuestionCategory.create(this.form);

      if (this.form.project_id) {
        await this.attachCategoryToProject({ category_id: response.data.data.id });
      }

      this.close();
    },

    async attachCategoryToProject({ category_id }) {
      const params = {
        category_ids: [{ category_id }],
      };
      await projectService.attachCategory(this.form.project_id, params);
    },
  },
};
</script>

<style></style>
